// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_80-6";
export var headerCell = "_80-2";
export var loadingStateContent = "_80-8";
export var rowWrapper = "_80-4";
export var stickyAggregationCell = "_80-b";
export var stickyAggregationRow = "_80-7";
export var stickyColumnCell = "_80-a";
export var stickyColumnHeaderCell = "_80-9";
export var table = "_80-1";
export var virtualRowWrapper = "_80-5";
export var virtualTableBodyFiller = "_80-d";
export var virtualTableBodyFillerBottom = "_80-e";
export var virtualTableContainer = "_80-0";
export var virtualTableContainerFill = "_80-c";
export var white = "_80-3";